export default "__VITE_ASSET__Duu$lHfX__"